import { getApiUrl } from './apiConfig';

function appendQueryParams(base, params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '') {
      q.set(key, String(value));
    }
  });
  const query = q.toString();
  return query ? `${base}?${query}` : base;
}

/** List exercises; pass viewerId/studentId to enforce assignment-based visibility. */
export function exercisesListUrl({
  exerciseTypeId,
  courseId,
  gradeId,
  studentId,
  viewerId,
  forAssignment,
  nonCourseOnly,
} = {}) {
  return appendQueryParams(`${getApiUrl()}/api/exercises`, {
    exercise_type_id: exerciseTypeId,
    course_id: courseId,
    grade_id: gradeId,
    student_id: studentId,
    viewer_id: viewerId,
    for_assignment: forAssignment ? 'true' : undefined,
    non_course_only: nonCourseOnly ? 'true' : undefined,
  });
}

export function exerciseByIdUrl(exerciseId, { studentId, viewerId } = {}) {
  return appendQueryParams(`${getApiUrl()}/api/exercises/${exerciseId}`, {
    student_id: studentId,
    viewer_id: viewerId ?? studentId,
  });
}

export function exerciseTypesByCourseUrl(courseId, { studentId, viewerId, forAssignment } = {}) {
  return appendQueryParams(`${getApiUrl()}/api/exercise-types/course/${courseId}`, {
    student_id: studentId,
    viewer_id: viewerId ?? studentId,
    for_assignment: forAssignment ? 'true' : undefined,
  });
}

/** Exercise types linked to a grade via exercise_type_grade (builder / admin listing). */
export function exerciseTypesByGradeUrl(gradeId, { studentId, viewerId, forAssignment } = {}) {
  return appendQueryParams(
    `${getApiUrl()}/api/exercise-types/grade/${encodeURIComponent(String(gradeId))}`,
    {
      student_id: studentId,
      viewer_id: viewerId ?? studentId,
      for_assignment: forAssignment ? 'true' : undefined,
    }
  );
}

/** Exercise types with no course or grade link, filtered by viewer assignment access. */
export function nonCourseExerciseTypesUrl({ studentId, viewerId, forAssignment } = {}) {
  return appendQueryParams(`${getApiUrl()}/api/exercise-types/non-course`, {
    student_id: studentId,
    viewer_id: viewerId ?? studentId,
    for_assignment: forAssignment ? 'true' : undefined,
  });
}

export function exerciseRemoveDisplayImageUrl(exerciseId) {
  return `${getApiUrl()}/api/exercises/${encodeURIComponent(String(exerciseId))}/remove-display-image`;
}

export function exerciseRemoveDisplayVideoUrl(exerciseId) {
  return `${getApiUrl()}/api/exercises/${encodeURIComponent(String(exerciseId))}/remove-display-video`;
}
